var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.039,
    height: 22.818,
    viewBox: "0 0 19.039 22.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "power-switch_1_",
    "data-name": "power-switch (1)",
    transform: "translate(-5.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M19.383,16.139a.925.925,0,1,0-.856,1.64,7.012,7.012,0,0,1,3.886,6.168,7.422,7.422,0,0,1-7.594,7.131,7.422,7.422,0,0,1-7.594-7.131,6.9,6.9,0,0,1,3.815-6.168.973.973,0,0,0-.927-1.711A9.262,9.262,0,0,0,5.3,24.054a9.331,9.331,0,0,0,9.519,9.02,9.331,9.331,0,0,0,9.519-9.02A9.012,9.012,0,0,0,19.383,16.139Z",
    transform: "translate(0 -10.256)",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M30.263,12.372a.917.917,0,0,0,.963-.963V.963a.963.963,0,1,0-1.925,0V11.409A.917.917,0,0,0,30.263,12.372Z",
    transform: "translate(-15.443)",
    fill: "#c06c84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/SignOutIcon.2f9661abe36dc0e87f75d5aa020f9b70.svg";
export { ForwardRef as ReactComponent };